// src/components/EvidenceGallery.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import moment from 'moment';
import ReactPlayer from 'react-player';
import { addEventEvidence, getEventEvidence, getEventsDataById, deleteEventEvidence } from '../../../../services/CommonService';
import { imgURL } from '../../../Config';

const Evidence = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [evidences, setEvidences] = useState([]);
  const [error, setError] = useState(null);
  const [type, setType] = useState('');
  const [file, setFile] = useState(null);
  const [link, setLink] = useState('');
  const [media_path, setMediaPath] = useState('');
  const [validated, setValidated] = useState(false);
  const [typeofEvidence, setTypeofEvidence] = useState("");
  const [typeofMode, setTypeofMode] = useState("");

  useEffect(() => {
    fetchEventDetails();
    fetchEvidences();
    const lookupData = JSON.parse(localStorage.getItem('lookup'));
    setTypeofEvidence(lookupData.filter((m) => m.Flag == '4'));
    setTypeofMode(lookupData.filter((m) => m.Flag == '7'))
  }, [id]);

  const fetchEventDetails = async () => {
    try {
      const response = await getEventsDataById(id);
      setEvent(response.data);
      setError(null);
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err?.response?.data?.message || err?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
    }
  };

  const fetchEvidences = async () => {
    try {
      const response = await getEventEvidence(id);
      setEvidences(response.data);
      setError(null);
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err?.response?.data?.message || err?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
    }
  };

  const handleTypeChange = (e) => {
    if (e.target.name == 'type' && e.target.value == 2) {
      setType(e.target.value);
      setLink(2);
      setFile(null);
      setMediaPath('');
    } else if (e.target.name == 'type') {
      setType(e.target.value);
    } else if (e.target.name == 'link') {
      setLink(e.target.value);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleVideoLinkChange = (e) => {
    setMediaPath(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    if (!form.checkValidity()) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);

    try {
      const formData = new FormData();
      formData.append('event_id', id);
      formData.append('type', type);
      formData.append('link', link);

      if (type == 1 && link == 1 && file) {
        formData.append('media_path', file);
      } else if (type == 2 && media_path) {
        formData.append('media_path', media_path);
      } else {
        Swal.fire('Error!', 'Please provide either a file or a video link', 'error');
        return;
      }
      await addEventEvidence(formData);

      Swal.fire('Success!', 'Evidence added successfully', 'success');
      setFile(null);
      setMediaPath('');
      setValidated(false);
      fetchEvidences();
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err?.response?.data?.message || err?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const dateFormat = (d) => {
    return d ? moment(d).format('DD-MM-YYYY') : ''
  }

  const handleDelete = (evidenceId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteEventEvidence(evidenceId);
          Swal.fire('Deleted!', 'Evidence has been deleted.', 'success');
          fetchEvidences();
        } catch (err) {
          Swal.fire({
            title: "Error",
            text: err?.response?.data?.message || err?.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  return (
    <div className="container-fluid my-4">
      <div className="card">
        <div className="card-header adminCardHeader d-flex justify-content-between align-items-center">
          <h4>Evidence Gallery</h4>
          <button className="btn btn-sm btn-warning" onClick={() => navigate('../eventlist')}>
            <i className="bi bi-arrow-left me-1" />Back
          </button>
        </div>
        <div className="card-body">
          <div className="mb-4">
            <h6><b>Event Name:</b> {event?.title || 'Loading...'}</h6>
            <hr />
            <h4>Add New Evidence</h4>
            <hr />
            <form
              noValidate
              className={`needs-validation ${validated ? 'was-validated' : ''}`}
              onSubmit={handleSubmit}
            >
              <div className="row mb-3">
                <div className="col-md-2">
                  <label htmlFor="type" className="form-label">
                    Evidence Type <span className="text-danger">*</span>
                  </label>
                  <select
                    name="type"
                    id="type"
                    value={type}
                    onChange={handleTypeChange}
                    className={`form-select ${validated && !type ? 'is-invalid' : ''}`}
                    required
                  >
                    <option value="">Select Type</option>
                    {typeofEvidence &&
                      typeofEvidence.map((m) => (
                        <option key={m.LookupCode} value={m.LookupCode}>
                          {m.LookupValue}
                        </option>
                      ))
                    }
                  </select>
                  {validated && !type && (
                    <div className="invalid-feedback">Please select an evidence type.</div>
                  )}
                </div>
                <div className="col-md-2">
                  <label htmlFor="link" className="form-label">
                    Mode <span className="text-danger">*</span>
                  </label>
                  <select
                    name="link"
                    id="link"
                    value={link}
                    onChange={handleTypeChange}
                    className={`form-select ${validated &&
                      type !== '2' && !link ? 'is-invalid' : ''}`}
                    disabled={type === '2'}
                    required
                  >
                    <option value="">Select Mode</option>
                    {typeofMode &&
                      typeofMode.map((m) => (
                        <option key={m.LookupCode} value={m.LookupCode}>
                          {m.LookupValue}
                        </option>
                      ))
                    }
                  </select>
                  {validated && type !== '2' && !link && (
                    <div className="invalid-feedback">Please select a mode.</div>
                  )}
                </div>
                {(type == 1 && link == 1) ? (
                  <div className="col-md-6">
                    <label htmlFor="fileUpload" className="form-label">Select Image</label>
                    <input
                      type="file"
                      className="form-control p-2"
                      id="fileUpload"
                      onChange={handleFileChange}
                      required
                      accept="image/*"
                    />
                    <div className="invalid-feedback">Please select a file.</div>
                  </div>
                ) : (
                  <div className="col-md-6">
                    <label htmlFor="media_path" className="form-label">URL</label>
                    <input
                      type="url"
                      className="form-control p-2"
                      id="media_path"
                      value={media_path}
                      onChange={handleVideoLinkChange}
                      required
                      placeholder="URL"
                    />
                    <div className="invalid-feedback">Please provide a valid URL.</div>
                  </div>
                )}
                <div className="col-md-2 text-end">
                  <br />
                  <button type="submit" className="btn btn-md btn-warning mt-2">
                    Submit Evidence
                  </button>
                </div>
              </div>

            </form>
          </div>
          <hr />
          <div>
            <h4>Uploaded Evidence</h4>
            <hr />
            {(evidences.length === 0) ? (
              <p>No evidence uploaded yet.</p>
            ) : (
              <div className="row">
                {evidences.map((evidence, index) => (
                  <div className="col-md-4 mb-4" key={evidence.id || index}>
                    <div className="card h-100 position-relative overflow-hidden">

                      {/* Delete button in top-right corner */}
                      <button
                        className="btn btn-sm btn-danger position-absolute"
                        style={{ top: '10px', right: '10px', zIndex: 2 }}
                        onClick={() => handleDelete(evidence.id)}
                      >
                        <i className="fas fa-trash"></i>
                      </button>

                      {/* Media content */}
                      {(evidence.type == 2 && evidence.link == 2) ? (
                        <div className="ratio ratio-16x9">
                          <ReactPlayer
                            url={evidence.media_path}
                            controls
                            width="100%"
                            height="100%"
                            config={{
                              file: {
                                attributes: {
                                  style: { objectFit: 'cover' }
                                }
                              }
                            }}
                          />
                        </div>
                      ) : (
                        <div className="ratio ratio-16x9">
                          <img
                            src={(evidence.type == 1 && evidence.link == 1) ? imgURL + evidence.media_path : evidence.media_path}
                            className="card-img-top"
                            alt={`Event Evidence ${index + 1}`}
                            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                          />
                        </div>
                      )}

                    </div>
                  </div>

                ))}
              </div>
            )}
          </div>
        </div>
      </div >
    </div >
  );
};

export default Evidence;
